import baseApplyEach from "../_internal/baseApplyEach.js";
import mapC from "./mapC.js";
import objectC from "./objectC.js";

export default baseApplyEach(mapC, objectC);
